var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1),_c('v-snackbar',{attrs:{"top":""},model:{value:(_vm.$store.state.notice),callback:function ($$v) {_vm.$set(_vm.$store.state, "notice", $$v)},expression:"$store.state.notice"}},[_vm._v(" "+_vm._s(_vm.$store.state.notice_msg)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }